import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VersionHistoryService {
  private visible$ = new BehaviorSubject<boolean>(false);

  /** Observable used by consumers (e.g., login component) to show/hide the version history panel. */
  visibilityChanges = this.visible$.asObservable();

  /** Show the version history panel. */
  open(): void {
    this.visible$.next(true);
  }

  /** Hide the version history panel. */
  close(): void {
    this.visible$.next(false);
  }
}
